import { AimOutlined, MinusCircleFilled, PlusCircleFilled } from '@ant-design/icons';

import { cn } from '@lcsc-ui/lib/utils';

export default function SchCanvas({
  containerId = 'containerId',
  className = '',
  size = 630,
  svgStr,
  control = true,
  svgDataFetched = true,
  productModel,
  onClick,
}) {
  return (
    <div
      id={containerId}
      className={cn('relative border border-solid border-[#d9d9d9]', className)}
      style={{ width: `${size}px`, height: `${size}px` }}
      onClick={onClick}
    >
      {!svgDataFetched || svgStr ? (
        <>
          <div
            dangerouslySetInnerHTML={{
              __html: `
                <svg
                  role="img"
                  aria-labelledby="svg-title svg-desc"
                  id="root2"
                  width="${size}"
                  height="${size}"
                  style="left:0;top:0"
                  viewBox="0 0 366 366"
                  preserveAspectRatio="xMinYMin"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  xmlns:c="https://easyeda.com/"
                  className="bw-firefox"
                >
                  <title id="svg-title">焊盘图</title>
                  <desc id="svg-desc">此图展示了型号为 ${productModel} 的焊盘布局</desc>
                  <rect
                    id="gridBg"
                    pointer-events="none"
                    x="0"
                    y="0"
                    width="366"
                    height="366"
                    fill="#000000"
                    stroke="none"
                  ></rect>
                  <defs id="patterns2">
                    <pattern id="${containerId}_gridPattern22" x="0" y="0" width="10" height="10" patternUnits="userSpaceOnUse">
                      <path
                        id="gridCell22"
                        d="M10 0V10H0"
                        fill="none"
                        stroke="#CCCCCC"
                        stroke-width="1"
                        stroke-opacity=".8"
                      ></path>
                    </pattern>
                  </defs>
                  <rect
                    id="grid12"
                    pointer-events="none"
                    x="0"
                    y="0"
                    width="366"
                    height="366"
                    fill="url(#${containerId}_gridPattern22)"
                    fill-opacity="0.8"
                    stroke="none"
                    shape-rendering="crispEdges"
                  ></rect>
                  <line
                    id="gridOH2"
                    pointer-events="none"
                    x1="0"
                    y1="180"
                    x2="366"
                    y2="180"
                    stroke="#ffffff"
                    stroke-width="1"
                    stroke-opacity="0"
                  ></line>
                  <line
                    id="gridOV2"
                    pointer-events="none"
                    x1="180"
                    y1="0"
                    x2="180"
                    y2="366"
                    stroke="#ffffff"
                    stroke-width="1"
                    stroke-opacity="0"
                  ></line>
                  <g id="g12">
                    ${svgStr}
                  </g>
                  <g id="gNets" pointer-events="none" font-size="1" stroke-width="0.02">
                    <text id="textTemp" dy="0.35em" x="0" y="0"></text>
                  </g>
                </svg>
              `,
            }}
          ></div>
          {control && (
            <div className="absolute bottom-[5px] right-[5px] flex">
              <div id="rootreset2">
                <AimOutlined className="w-[22px] cursor-pointer text-[16px] text-[#FFF]" />
              </div>
              <div id="rootsmaller2">
                <MinusCircleFilled className="w-[22px] cursor-pointer text-[16px] text-[#FFF]" />
              </div>
              <div id="rootlarger2">
                <PlusCircleFilled className="w-[20px] cursor-pointer text-[16px] text-[#FFF]" />
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="mt-[50%] translate-y-[-50%] text-center text-[16px] font-bold">暂未绘制...</div>
      )}
    </div>
  );
}
